import React from 'react'
import Chip from '@material-ui/core/Chip'

// Chips can only render primitive values as their label; item types like
// `object`/`array` have no generic string form, so they cannot be represented
// in this component.
const PRIMITIVE_ITEM_TYPES = [
  'string',
  'number',
  'boolean',
  'date-time',
  'color',
]

const CustomArrayField = ({ property, name, record, ...rest }) => {
  if (!PRIMITIVE_ITEM_TYPES.includes(property?.items?.type)) return <span />
  return (
    <div
      style={{
        display: 'flex',
      }}
    >
      {record &&
        record[name] &&
        record[name].map((item, index) => (
          <Chip
            key={index}
            label={item}
            size='small'
          />
        ))}
    </div>
  )
}

CustomArrayField.defaultProps = {
  addLabel: true,
}

export default CustomArrayField
